import {mutation, query} from "@/graphql/client";
import {gql} from "@urql/vue";
import {Demand, ShiftType} from "@/graphql/generated/graphql";
import {addressFragment, clientFragment, houseFragment, jobsiteDetailsFragment, jobsiteFragment} from "./jobsite";
import {listFormat, pluralizeHuman, pluralizeUnitOnly} from "@/helper/amountFormatter";
import {sortShifts, uniqueShifts} from "@/helper/shiftTypes";
import {kapitelDateString} from "@/graphql/kapitelTypes";
import {getArrayUnique} from "@/helper/array";
import {graphql} from "@/graphql/generated";



export const getDemand = async (ids: Array<number>): Promise<any> => {
    const result = await query(graphql(`
        
        
        
            query QueryDemand (
                $ids: [Int!]!
            ){
              demandByIds (
                ids: $ids
              ){
                id,
                date,
                begin,
                until,
                shiftType,
                jobsite {
                    ...JobsiteFragment
                    client {
                        ...ClientFragment
                    }
                    house {
                        ...HouseFragment
                    }
                },
                isWishDemand
              }
        }`),
        {
            ids: ids
        }
    )

    return result?.data?.demandByIds
}

export async function availabilityFromDemand(demandId: number): Promise<any> {

    const MUTATION = graphql(`
            mutation AddAvailabilityFromDemand (
                $demandIdDings: Int!
            ) {
                availabilityFromDemand(
                    demandId: $demandIdDings,
                )
            }`)

    const result = await mutation(
        MUTATION, {
            demandIdDings: demandId,
        }
    )

    const response = result?.data?.availabilityFromDemand

    if (!response) {
        return 'Fehler beim Speichern'
    }

    return response
}

export const generateDemandSuggestionsRenderSet = (demand: Array<Demand>, maxEnumarationValues = 2) => {
    const jobsites = getArrayUnique(demand.map(ds => ds.jobsite), j => j.id)
    const jobsiteLabel = jobsites.length > maxEnumarationValues ? pluralizeHuman(jobsites.length, 'einer Station', 'Stationen') : listFormat(jobsites.map(js => js?.abbreviation || ''))
    const shifts = uniqueShifts(demand.map(ds => ds.shiftType)).toSorted(sortShifts)
    const shiftLabel = listFormat(shifts)
    const count = demand.length
    const shortLabel = pluralizeHuman(count, 'ein offener ', 'offene ') + shiftLabel
    const label = pluralizeUnitOnly(count, 'Offener ', 'Offene ')  + shiftLabel + ' auf ' + jobsiteLabel

    return {
        count,
        jobsites,
        jobsiteLabel,
        shifts,
        shiftLabel,
        label,
        shortLabel
    }
}

export const getDemandBuckets = async (begin: kapitelDateString, until: kapitelDateString|undefined, jobsiteIds: number[]|null, shiftSelection: ShiftType[]|undefined): Promise<any> => {
    const result = await query(graphql(`
            
            
            
            
            query QueryDemandBuckets (
                $jobsiteIds: [Int!]
                $begin: KapitelDateImmutable!
                $until: KapitelDateImmutable
                $shiftTypes: [ShiftType!]
            ){
                demandBuckets (
                    jobsiteIds: $jobsiteIds
                    begin: $begin
                    until: $until
                    shifts: $shiftTypes
                ) {
                    ... on DemandBucketManyJobsites {
                        offeneDiensteStationen
                        offeneDienstMenge
                        ehemalsOffeneDienstMenge
                        gesamtDienstMenge
                        gesamtDiensteStationen
                    }
                    ... on DemandBucketSingleJobsite {
                        #konkreteOffeneDienste
                        #schichtenGesamtDienste
                        #schichtenOffeneDienste
                        offeneDienstMenge
                        offeneDienstMengeFuzzy
                        ehemalsOffeneDienstMenge
                        ehemalsOffeneDienstMengeFuzzy
                        gesamtDienstMenge
                        gesamtDienstMengeFuzzy
                        durchschnittlicheMonatlicheDienste

                        offeneDiensteMonate
                        offeneDiensteZeitraeumeWennWenige
                        
                        jobsite {
                            ...JobsiteDetailsFragment
                            client {
                                ...ClientFragment
                                address {
                                    ...AddressFragment
                                }
                            }
                            house {
                                ...HouseFragment
                                address {
                                    ...AddressFragment
                                }
                            }
                        }
                    }
                }
            }`),
        {
            jobsiteIds: jobsiteIds,
            begin: begin,
            until: until,
            shiftTypes: shiftSelection,
        }
    )

    return result?.data?.demandBuckets
}
